import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Animated gradient fill on headline words.
 */
export const GradientText = ({ children, className = "" }) => {
  const reduced = usePreferStaticUI();

  if (reduced) {
    return <span className={className}>{children}</span>;
  }

  return (
    <motion.span
      className={`bg-clip-text text-transparent ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(90deg, #14100F 0%, #9E4A62 35%, #4A3F6B 65%, #14100F 100%)",
        backgroundSize: "200% auto",
      }}
      animate={{ backgroundPosition: ["0% center", "200% center", "0% center"] }}
      transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
    >
      {children}
    </motion.span>
  );
};

export default GradientText;
